import React, { useEffect, useState } from "react";
import {
  TextInput,
  Row,
  Column,
  FormGroup,
  RadioButtonGroup,
  RadioButton,
  TextArea,
  Checkbox,
} from "carbon-components-react";
import useGet from "../../hooks/useGet";
import ProvinceCombo from "../Combos/ProvinceCombo";
import DistrictCombo from "../Combos/DistrictCombo";
import { NumberInput } from "carbon-components-react";

const ExistingBusinessProfileForm = ({
  disabled,
  register,
  control,
  errors,
  businessPlan,
}) => {
  const { data: legalForms } = useGet("/utils/legal-forms");

  return (
    <FormGroup
      legendText="2. PERFIL DE NEGÓCIO – EMPRESAS EXISTENTES"
      className="section-header"
    >
      <h6 className="section-subtitle">
        A ser preenchida somente por candidatos/as que têm um negócio
        actualmente
      </h6>
      <fieldset className="bx--fieldset required">
        <legend className="bx--label">2.1 Tipo de Negócio</legend>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              [Seleccione o tipo de negócio.]
            </div>
          </Column>
        </Row>
        <Row>
          <Column sm={12} md={3} lg={3}>
            <Checkbox
              labelText="Fabricante/Produtor "
              id="isBusinessManufacturerOrProducer"
              disabled={disabled}
              {...register("isBusinessManufacturerOrProducer")}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Checkbox
              labelText="Prestador de serviço "
              id="isBusinessServiceProvider"
              disabled={disabled}
              {...register("isBusinessServiceProvider")}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Checkbox
              labelText="Retalhista "
              id="isBusinessRetailer"
              disabled={disabled}
              {...register("isBusinessRetailer")}
            />
          </Column>
          <Column sm={12} md={3} lg={3}>
            <Checkbox
              labelText="Grossista/Vendedores a Grosso"
              id="isBusinessWholesaler"
              disabled={disabled}
              {...register("isBusinessWholesaler")}
            />
          </Column>
          <p className="field-error">{errors.businessType?.message}</p>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset required" style={{ marginBottom: "0" }}>
        <legend className="bx--label">
          2.2 Licenciamento da actividade que exerce{" "}
        </legend>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              Possui o Alvará ou licenças necessárias para a actividade que
              exerce actualmente?
            </div>
          </Column>
          <Column>
            <RadioButtonGroup
              name="hasPermitOrLicenses"
              disabled={disabled}
              valueSelected={businessPlan?.hasPermitOrLicenses}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="has-permit-y"
                {...register("hasPermitOrLicenses")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="has-permit-n"
                {...register("hasPermitOrLicenses")}
              />
            </RadioButtonGroup>
            <p className="field-error">{errors.hasPermitOrLicenses?.message}</p>
          </Column>
        </Row>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              Possui a licença ambiental para as actividades de categoria C?
            </div>
          </Column>
          <Column>
            <RadioButtonGroup
              name="hasEnvironmentalLicenseForCategoryC"
              disabled={disabled}
              valueSelected={businessPlan?.hasEnvironmentalLicenseForCategoryC}
            >
              <RadioButton
                labelText="Sim"
                value={true}
                id="env-permit-y"
                {...register("hasEnvironmentalLicenseForCategoryC")}
              />
              <RadioButton
                labelText="Não"
                value={false}
                id="env-permit-n"
                {...register("hasEnvironmentalLicenseForCategoryC")}
              />
            </RadioButtonGroup>
            <p className="field-error">
              {errors.hasEnvironmentalLicenseForCategoryC?.message}
            </p>
          </Column>
        </Row>
      </fieldset>

      <fieldset className="bx--fieldset legal-form">
        <legend className="bx--label">2.3 Forma Legal do Negócio </legend>
        <Row>
          <Column sm={12} md={12} lg={12}>
            <div className="bx--form__helper-text">
              [Seleccione a forma legal do seu negócio.]
            </div>

            <RadioButtonGroup
              legend="Group Legend"
              name="legalFormOfBusinessCode"
              orientation="horizontal"
              disabled={disabled}
              valueSelected={businessPlan?.legalFormOfBusinessCode}
            >
              {legalForms.map((lf) => (
                <RadioButton
                  id={"lfb-" + lf.code}
                  key={"lfb-" + lf.code}
                  labelText={lf.description}
                  value={lf.code}
                  {...register("legalFormOfBusinessCode")}
                />
              ))}
            </RadioButtonGroup>
            <p className="field-error">
              {errors.legalFormOfBusinessCode?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="businessProductOrService"
              labelText="2.4 Tipo de Produto(s)/Serviço(s) que produz/vende/oferece"
              rows={8}
              enableCounter
              disabled={disabled}
              helperText="[Descreva de forma sumária, o(s) produto(s)/serviço(s) que actualmente produz/vende/oferece, enunciando as suas principais características e o grau de desenvolvimento. Use no máximo 100 palavras.]"
              {...register("businessProductOrService")}
            />
            <p className="field-error">
              {errors.businessProductOrService?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="businessHistory"
              labelText="2.5	Breve Historial do Negócio"
              rows={8}
              enableCounter
              disabled={disabled}
              helperText="[Descreva de forma breve, como o negócio foi criado e os principais desenvolvimentos até a data. Use no máximo 100 palavras.]"
              {...register("businessHistory")}
            />
            <p className="field-error">{errors.businessHistory?.message}</p>
          </Column>
        </Row>
      </fieldset>
    </FormGroup>
  );
};

ExistingBusinessProfileForm.defaultProps = {
  disabled: false,
};

export default ExistingBusinessProfileForm;
